import { render } from "./ManageFacilities.vue?vue&type=template&id=14c2f024&scoped=true&ts=true"
import script from "./ManageFacilities.vue?vue&type=script&lang=ts"
export * from "./ManageFacilities.vue?vue&type=script&lang=ts"

import "./ManageFacilities.vue?vue&type=style&index=0&id=14c2f024&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c2f024"]])

export default __exports__